// extracted by mini-css-extract-plugin
module.exports = {"TileParagraph":"styles_TileParagraph__1hI5r","WelcomeTile__Interests":"styles_WelcomeTile__Interests__1svuE"};